import $ from 'jquery';

function getCountdown() {
    const now = new Date();
    const austTime = new Date(now.toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
    const startOfDay = new Date(austTime.getFullYear(), austTime.getMonth(), austTime.getDate(), 0, 0, 0);

    const secondsInDay = 24 * 60 * 60;
    const elapsedSeconds = (austTime - startOfDay) / 1000;

    let countdown = 100 - Math.floor((elapsedSeconds / secondsInDay) * 100);
    if (countdown === 0) countdown = 1;

    $(".timer-left span").text(countdown);
}

function updateCountdown() {
    getCountdown();
    setTimeout(updateCountdown, 1000); // Update every second
}

document.addEventListener("DOMContentLoaded", updateCountdown);